import { prettifyAttoAlphAmount, prettifyTokenAmount, web3 } from "@alephium/web3";
import { useWallet } from "@alephium/web3-react";
import { useEffect, useState } from "react";
import { Leaderboard, LeaderboardTypes, RocketRange } from "src/artifacts/ts";
import { LeaderboardEntry, RocketRangeGameInstance } from "src/artifacts/ts/types";
import { formatAddress, formatTimeAgo } from "src/components/utils/Formatters";
import { getContractConfig } from "src/services/utils";
import RocketRangeBar from "./RocketRangeBar";
import RocketRangeLTW from "./RocketRangeLTW";



interface RocketRangePastRoundProps {
    gameData: RocketRangeGameInstance;
}

const RocketRangePastRound: React.FC<RocketRangePastRoundProps> = ({ gameData }) => {
    const resultMap = {
        1: "Down 4%+",
        2: "Down 1-4%",
        3: "No Change",
        4: "Up 1-4%",
        5: "Up 4%+",
    };

    return (
        <div className="bg-gray-900 rounded-lg p-4 shadow-md m-6">
            {/* Header */}
            <div className="flex justify-between items-center mb-4">
                <h2 className="font-bold text-white">
                    <span className="text-lg">Round #{gameData.gameId + ""} - {prettifyAttoAlphAmount(gameData.totalPotSize)}</span>
                    <span className="text-xs"> ALPH</span>
                </h2>
            </div>

            <div className="mb-4">
                <RocketRangeLTW from={gameData.betCloseTime} to={gameData.gameEndTime} openPrice={gameData.openPrice} />
            </div>

            {/* Chart */}
            <div className="mb-4">
                <RocketRangeBar gameData={gameData} />
            </div>

            {/* Inline Information */}
            <div className="text-sm text-gray-400 space-y-4">
                {/* Open Price */}
                <div className="flex justify-between items-center">
                    <span className="text-gray-300">Open:</span>
                    <span className="text-gray-400 font-bold">
                        {new Date(Number(gameData.betCloseTime)).toLocaleString("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                        })}{" "}
                        <span className="text-red-500">{" $" + prettifyTokenAmount(gameData.openPrice, 8)}</span>
                    </span>
                </div>

                {/* Close Price */}
                <div className="flex justify-between items-center">
                    <span className="text-gray-300">Close:</span>
                    <span className="text-gray-400 font-bold">
                        {new Date(Number(gameData.gameEndTime)).toLocaleString("en-US", {
                            month: "2-digit",
                            day: "2-digit",
                            hour: "2-digit",
                            minute: "2-digit",
                        })}{" "}
                        <span className="text-red-500">{" $" + prettifyTokenAmount(gameData.closePrice, 8)}</span>
                    </span>
                </div>

                {/* Winners */}
                <div className="flex justify-between items-center">
                    <span className="text-gray-300">Winners:</span>
                    <span className="text-green-500 font-bold">{resultMap[gameData.result + ""] || "Round not closed"}</span>
                </div>
            </div>
        </div>
    );
}


export default RocketRangePastRound;